import type { Language } from '@packages/config';
import config from '@packages/config';
import type { CmsData } from '../../../interfaces/webapp_json';

export const schemaData = (data: CmsData) => {
  const {
    field_headline_long: headline,
    field_description_long: description,
    taxonomy_term: taxonomy,
    file,
    created,
    changed,
    path,
    langcode,
  } = data;
  const {
    headerInformation,
    host: { domain },
    tracking: {
      schemaOrgOrganisation: {
        'de-DE': { logo },
      },
    },
  } = config;
  const canonical = headerInformation[langcode as Language]?.canonical;
  let pageUrl;
  try {
    pageUrl = new URL(path?.[0].alias, canonical);
  } catch {
    pageUrl = path?.[0].alias;
  }
  // The fetchers relativize the image url to the /cms-images proxy; schema.org needs it absolute.
  let imageUrl = file?.[0].url;
  try {
    imageUrl = imageUrl && new URL(imageUrl, canonical).href;
  } catch {
    // without a canonical the relative url stays as delivered
  }
  return {
    '@context': 'https://schema.org/',
    '@type': 'Article',
    name: headline,
    description,
    headline,
    keywords: taxonomy?.map((keyword) => keyword.name),
    image: {
      '@type': 'ImageObject',
      url: imageUrl,
      caption: file?.[0].data.alt,
    },
    about: {
      '@type': 'BlogPost',
      name: headline,
    },
    datePublished: created,
    dateModified: changed,
    url: pageUrl.href,
    publisher: {
      '@type': 'Organization',
      name: domain,
      logo,
    },
    author: {
      '@type': 'Organization',
      name: domain,
      url: canonical,
      logo,
    },
  };
};

export const SchemaOrg = ({ data }: { data: CmsData }) => {
  if (data.type !== 'magazin_content') {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData(data)) }}
    />
  );
};
